import baseURL from "../../utils/API_URL";
import axios from "axios";

async function callApiLogin(email, password) {
  const url = baseURL + "api/login";
  const body = {
    username: email,
    is_test: localStorage.getItem("Test") === "true",
    password,
  };

  const headers = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };

  const response = await axios.post(url, body, { headers });
  return response.data?.token || "";
}

async function callApiRegister(newUser) {
  const url = baseURL + "api/create-request";
  const body = {
    name: newUser.userName,
    email: newUser.userEmail,
    phone: newUser.userPhone,
    is_test: localStorage.getItem("Test") === "true",
    call_phone: newUser.userPhone,
    company_name: newUser.userCompany || "EPIC03",
    company_address: newUser.company_address || "",
    equip: newUser.equipment || "",
    serial: newUser.equipment_serial || "",
    title: "Register",
    message: newUser.comment || "Register",
  };

  const headers = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };

  const response = await axios.post(url, body, { headers });
  return response.data?.Data?.HDCaseNum;
}

async function callApiChangePassword(oldPass, newPass, token) {
  const url = baseURL + "api/changepass";
  const body = {
    old_pass: oldPass,
    new_pass: newPass,
  };

  const headers = {
    Authorization: "Bearer " + token,
    Accept: "*/*",
    "Content-Type": "application/json",
  };

  const response = await axios.post(url, body, { headers });
  return response.data;
}

async function callBAQ(baq, param, token) {
  const url = baseURL + "api/call-baq";
  const body = {
    CompanyID: "EPIC03",
    PlantID: "MfgSys",
    Company: "EPIC03",
    Plant: "MfgSys",
    QueryID: baq,
    IsTest: false,
    Mode: 0,
    UseNewDataFormat: true,
    Take: 0,
    Skip: 0,
    SortBy: null,
    SysRevID: 0,
    Parameters: param,
  };

  const headers = {
    Accept: "*/*",
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };

  const response = await axios.post(url, body, { headers });
  return JSON.parse(response.data.DataRaw || "[]");
}

export default {
  setIsDoneFalse(state) {
    state.isDone = false;
  },

  async login(state, payload) {
    state.isDone = false;
    state.loginErr = 0;

    try {
      const newToken = await callApiLogin(payload.email, payload.pass);

      state.token = newToken;
      state.isDone = true;
      state.loginErr = newToken ? 0 : 1;

      localStorage.setItem("token", newToken || "");
    } catch (error) {
      console.error("login error:", error);
      state.token = "";
      state.isDone = true;
      state.loginErr = 1;
      localStorage.setItem("token", "");
    }
  },

  async register(state, payload) {
    state.isDone = false;

    try {
      const caseNum = await callApiRegister(payload.user);
      state.hdcase = caseNum;
      state.isDone = true;
    } catch (error) {
      console.error("register error:", error);
      state.hdcase = undefined;
      state.isDone = true;
    }
  },

  resetCase(state) {
    state.hdcase = "";
  },

  async changePassword(state, payload) {
    state.isDone = false;

    const oldPass =
      payload.oldPassword ?? payload.old ?? payload.old_pass ?? "";

    const newPass =
      payload.newPassword ?? payload.newp ?? payload.new_pass ?? "";

    if (!oldPass || !newPass) {
      console.error("changePassword payload invalid:", payload);
      state.isDone = true;
      throw new Error("Old password or new password is missing.");
    }

    try {
      const token = state.token || localStorage.getItem("token") || "";

      if (!token) {
        state.isDone = true;
        throw new Error("Token is missing.");
      }

      const response = await callApiChangePassword(oldPass, newPass, token);
      console.log("changePassword response:", response);

      state.isDone = true;
      return response;
    } catch (error) {
      console.error("changePassword error:", error);
      state.isDone = true;
      throw error;
    }
  },

  logout(state) {
    localStorage.setItem("token", "");
    localStorage.removeItem("cust_num");
    localStorage.removeItem("uid");

    state.token = "";
    state.email = "";
    state.company = "";
    state.company_address = "";
    state.cust_id = "";
    state.cust_num = null;
    state.cust_name = "";
    state.cell_phone = "";
    state.phone = "";
    state.name = "";
    state.session = "";
    state.status = -1;
    state.uid = 0;
    state.loginErr = 0;
    state.isDone = false;
  },

  updateInfo(state, payload) {
    state.email = payload.user.email;
    state.cust_id = payload.user.cust_id;
    state.cust_num = payload.user.cust_num;
    state.cell_phone = payload.user.cell_phone;
    state.phone = payload.user.phone;
    state.name = payload.user.name;
    state.session = payload.user.session;
    state.status = payload.user.status;
    state.uid = payload.user.uid;

    localStorage.setItem("cust_num", payload.user.cust_num);
    localStorage.setItem("uid", payload.user.uid);
  },

  async DSPGetCompanyInfo(state) {
    try {
      const data = await callBAQ(
        "DSPGetCompanyInfo",
        {
          CustNum: String(localStorage.getItem("cust_num") || ""),
          PerconID: String(localStorage.getItem("uid") || ""),
        },
        localStorage.getItem("token"),
      );

      if (data.length > 0) {
        state.company = data[0].Customer_Company;
        state.cust_name = data[0].Customer_Name;
        state.cust_id = data[0].Customer_CustID;
        state.cust_num = data[0].Customer_CustNum;
        state.name = data[0].PerCon_Name;
        state.email = data[0].PerCon_EMailAddress;
        state.phone = data[0].PerCon_PhoneNum;
        state.permision.case = data[0].CustCnt_PortalCases_c;
        state.permision.call = data[0].CustCnt_PortalServiceCalls_c;
        state.permision.job = data[0].CustCnt_PortalServiceJobs_c;
        state.permision.equipment = data[0].CustCnt_PortalEquipments_c;
        state.permision.invoice = data[0].CustCnt_PortalInvoices_c;
        state.permision.contract = data[0].CustCnt_PortalServiceContracts_c;
        state.permision.order = data[0].CustCnt_PortalOrders_c;
        state.permision.shipment = data[0].CustCnt_PortShipments_c;
        state.permision.quote = data[0].CustCnt_PortalQuotes_c;
        state.permision.rma = data[0].CustCnt_PortalRMA_c;
      }
    } catch (error) {
      console.error("DSPGetCompanyInfo error:", error);
    }
  },
};
